import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { InsightsMessage } from '../../../hooks/useInsightsStream';
import { formatMessageContent } from '../insightsUtils';

interface InsightsMessageContentProps {
  message: InsightsMessage;
}

export const InsightsMessageContent = ({ message }: InsightsMessageContentProps) => {
  const formatted = formatMessageContent(message.content);
  if (message.type === 'human') {
    return <span>{formatted}</span>;
  }

  return (
    <div className="markdown-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ children, ...props }) => (
            <a {...props} target="_blank" rel="noreferrer">
              {children}
            </a>
          ),
          code: ({ children, className, ...props }) => {
            const languageMatch = typeof className === 'string' ? className.match(/language-(\w+)/) : null;
            const language = languageMatch?.[1]?.toLowerCase();

            if (language === 'sql') {
              return (
                <details className="markdown-sql-details">
                  <summary className="markdown-sql-summary">SQL</summary>
                  <pre className={className}>
                    <code {...props}>{children}</code>
                  </pre>
                </details>
              );
            }

            return (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
        }}
      >
        {formatted}
      </ReactMarkdown>
    </div>
  );
};
